import { render, staticRenderFns } from "./communityq_story_template_field.vue?vue&type=template&id=42f94364&lang=pug"
import script from "./communityq_story_template_field.vue?vue&type=script&lang=js"
export * from "./communityq_story_template_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports